import { render, staticRenderFns } from "./CustomerNumber.vue?vue&type=template&id=0931e1ed&"
import script from "./CustomerNumber.vue?vue&type=script&lang=js&"
export * from "./CustomerNumber.vue?vue&type=script&lang=js&"
import style0 from "./CustomerNumber.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports